import {
  AlignLeftIcon,
  CalendarClockIcon,
  CalendarIcon,
  CheckSquareIcon,
  ChevronDownIcon,
  CircleDotIcon,
  HashIcon,
  LayoutListIcon,
  ListIcon,
  PaperclipIcon,
  StarIcon,
  TypeIcon,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { FORM_FIELD_TYPE_LABEL_LA } from "@/modules/forms/presentation/ui/builder/form-field-defaults";
import type { FormFieldType } from "@/server/platform/db/schema/forms";

export type FormFieldTypeGroup = {
  id: string;
  label: string;
  types: FormFieldType[];
};

export const FORM_FIELD_TYPE_GROUPS: FormFieldTypeGroup[] = [
  {
    id: "layout",
    label: "ໂຄງສ້າງ",
    types: ["section"],
  },
  {
    id: "text",
    label: "ຂໍ້ຄວາມ",
    types: ["text", "textarea", "number"],
  },
  {
    id: "choice",
    label: "ຕົວເລືອກ",
    types: ["choice", "dropdown", "checkbox"],
  },
  {
    id: "datetime",
    label: "ວັນເວລາ",
    types: ["date", "datetime"],
  },
  {
    id: "media",
    label: "ໄຟລ໌ / ຄະແນນ",
    types: ["file", "rating"],
  },
  {
    id: "advanced",
    label: "ຂັ້ນສູງ",
    types: ["repeater"],
  },
];

const FIELD_TYPE_ICONS: Record<FormFieldType, LucideIcon> = {
  section: LayoutListIcon,
  text: TypeIcon,
  number: HashIcon,
  textarea: AlignLeftIcon,
  choice: CircleDotIcon,
  dropdown: ChevronDownIcon,
  checkbox: CheckSquareIcon,
  date: CalendarIcon,
  datetime: CalendarClockIcon,
  file: PaperclipIcon,
  rating: StarIcon,
  repeater: ListIcon,
};

const FIELD_TYPE_TONE: Record<
  FormFieldType,
  { badge: string; icon: string }
> = {
  section: {
    badge: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200",
    icon: "text-slate-600",
  },
  text: {
    badge: "bg-blue-50 text-blue-700 dark:bg-blue-950 dark:text-blue-200",
    icon: "text-blue-600",
  },
  number: {
    badge: "bg-blue-50 text-blue-700 dark:bg-blue-950 dark:text-blue-200",
    icon: "text-blue-600",
  },
  textarea: {
    badge: "bg-blue-50 text-blue-700 dark:bg-blue-950 dark:text-blue-200",
    icon: "text-blue-600",
  },
  choice: {
    badge: "bg-violet-50 text-violet-700 dark:bg-violet-950 dark:text-violet-200",
    icon: "text-violet-600",
  },
  dropdown: {
    badge: "bg-violet-50 text-violet-700 dark:bg-violet-950 dark:text-violet-200",
    icon: "text-violet-600",
  },
  checkbox: {
    badge: "bg-violet-50 text-violet-700 dark:bg-violet-950 dark:text-violet-200",
    icon: "text-violet-600",
  },
  date: {
    badge: "bg-amber-50 text-amber-800 dark:bg-amber-950 dark:text-amber-200",
    icon: "text-amber-700",
  },
  datetime: {
    badge: "bg-amber-50 text-amber-800 dark:bg-amber-950 dark:text-amber-200",
    icon: "text-amber-700",
  },
  file: {
    badge: "bg-emerald-50 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-200",
    icon: "text-emerald-700",
  },
  rating: {
    badge: "bg-emerald-50 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-200",
    icon: "text-emerald-700",
  },
  repeater: {
    badge: "bg-orange-50 text-orange-800 dark:bg-orange-950 dark:text-orange-200",
    icon: "text-orange-700",
  },
};

export function formFieldTypeIcon(type: FormFieldType): LucideIcon {
  return FIELD_TYPE_ICONS[type];
}

export function formFieldTypeLabel(type: FormFieldType): string {
  return FORM_FIELD_TYPE_LABEL_LA[type];
}

export function formFieldTypeTone(type: FormFieldType) {
  return FIELD_TYPE_TONE[type];
}
